import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { CheckCircle } from 'lucide-react'

const FormularioMedicoSucesso = () => {
  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="max-w-2xl mx-auto px-4">
        <Card className="border-green-200 bg-green-50/50">
          <CardHeader>
            <div className="flex flex-col items-center gap-4">
              <div className="rounded-full bg-green-100 p-4">
                <CheckCircle className="h-16 w-16 text-green-600" />
              </div>
              <CardTitle className="text-2xl font-bold text-center text-gray-900">
                Formulário Recebido!
              </CardTitle>
            </div>
          </CardHeader>
          <CardContent className="space-y-4 text-center">
            <p className="text-lg text-gray-700">
              Seu formulário médico pré-anestésico foi enviado com sucesso.
            </p>
            <p className="text-gray-600">
              Em breve nossa equipe analisará as informações. Em caso de dúvidas ou necessidade de complementação, entraremos em contato.
            </p>
            <p className="text-sm text-gray-500">
              Obrigado pela colaboração. Suas informações são importantes para sua segurança.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default FormularioMedicoSucesso
